import { render, staticRenderFns } from "./SettingLabel.vue?vue&type=template&id=34027797"
import script from "./SettingLabel.vue?vue&type=script&lang=js"
export * from "./SettingLabel.vue?vue&type=script&lang=js"
import style0 from "./SettingLabel.vue?vue&type=style&index=0&id=34027797&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports